<template>
  <div class="user-design">
    <div class="title">{{ $t('userDesign.MyDesign') }}</div>
    <div class="content bg-white">
      <div class="head f-b-c">
        <el-input v-model="listParams.searchContent" clearable :placeholder="$t('userDesign.Tips1')" size="small" style="width: 400px" @change="resetPage">
          <el-button slot="append" icon="el-icon-search" @click="resetPage"></el-button>
        </el-input>
        <div class="f--c">
          <div v-if="selection.length" style="margin:10px;">{{ selection.length }} {{ $t('userDesign.ProductSelected') }}</div>
          <el-button type="danger" size="small" :disabled="!selection.length" @click="delDesignedProduct()">Remove</el-button>
        </div>
      </div>
      <div class="design-table">
        <el-table ref="designTable" :data="list" height="calc(100vh - 240px)" style="width: 100%" @sort-change="sortTable" @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="50">
          </el-table-column>
          <el-table-column
            prop="description"
            label="Description"
            min-width="200">
            <div class="table-info f" slot-scope="{ row }">
              <el-popover placement="right" width="280" trigger="hover">
                <el-image :src="row.imageUrl" fit="cover" />
                <oss-img slot="reference" :width="50" :height="50" :src="row.imageUrl" class="img" />
              </el-popover>
              <div class="info-text">
                <el-tooltip class="item" effect="dark" :content="row.enName" placement="top-start">
                  <div class="ellipsis">{{ row.enName }}</div>
                </el-tooltip>
                <div class="code">{{ $t('userDesign.ItemNo') }}: {{ row.spu }}</div>
              </div>
            </div>
          </el-table-column>
          <el-table-column
            prop="price"
            :label="$t('userDesign.Price')"
            min-width="100"
            sortable>
          </el-table-column>
          <el-table-column
            prop="createDate"
            :label="$t('userDesign.DesignTime')"
            min-width="120"
            sortable>
            <template slot-scope="{ row }">
              <div>{{ row.createDate | dateFormat}}</div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('userDesign.Action')"
            width="140">
            <div slot-scope="{ row }" class="f--c">
              <el-button type="text" @click="dropdowmClick('Detail', row)">{{ $t('userDesign.Detail') }}</el-button>
              <el-button type="text" @click="dropdowmClick('Remove', row)" style="color:#F56C6C">{{ $t('userDesign.Remove') }}</el-button>
            </div>
            <!-- <el-dropdown slot-scope="{ row }" @command="command => dropdowmClick(command, row)">
              <div class="pointer color-green">
                <el-button type="text" style="margin-right:6px">{{ $t('userDesign.Actions') }}</el-button><i class="el-icon-arrow-down"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="Detail">{{ $t('userDesign.Detail') }}</el-dropdown-item>
                <el-dropdown-item command="Remove">{{ $t('userDesign.Remove') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
          </el-table-column>
        </el-table>
        <div class="foot f-b-c">
          <div class="left"></div>
          <el-pagination background :current-page="listParams.pageNumber" :page-sizes="[20, 30, 50, 100, 200]" :page-size="listParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      search: '',
      list: [],
      listParams: {
        pageNumber: 1,
        pageSize: 20
      },
      total: 0,
      selection: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      API.getDesignedProducts(this.listParams).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.total = res.data.total
        this.list = res.data.list
      })
    },

    delDesignedProduct(id) {
      this.$confirm(`${this.$t('userDesign.Tips2')}`, 'Notice', {
        confirmButtonText: this.$t('userDesign.Confirm'),
        cancelButtonText: this.$t('userDesign.Cancel'),
        type: 'warning'
      }).then(() => {
        API.delDesignedProduct({
          ids: id ? [id] : this.selection.map(t => t.id)
        }).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          this.resetPage()
        })
      })
    },

    resetPage() {
      this.listParams.pageNumber = 1
      this.getList()
    },

    // 当表格的排序条件发生变化的时候会触发该事件
    sortTable({ column, prop, order }) {
      this.$set(this.listParams, 'sortType', prop === 'createDate' ? (order === 'descending' ? 1 : order === 'ascending' ? 2 : undefined) : (order === 'descending' ? 6 : order === 'ascending' ? 5 : undefined))
      this.resetPage()
    },
    // 当表格复选框选择项发生变化时会触发该事件
    handleSelectionChange(selection) {
      this.selection = selection
    },

    handleCurrentChange(page) {
      this.listParams.pageNumber = page
      this.getList()
    },
    // 每页显示条数发生改变时的回调
    handleSizeChange(size) {
      this.listParams.pageSize = size
      this.getList()
    },

    dropdowmClick(command, row) {
      switch (command) {
        case 'Detail':
          this.jumpDetailSeo(row.kkProductId)
          break
        case 'Remove':
          this.delDesignedProduct(row.id)
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-design {
  padding: 20px 20px 0 36px;
  color: #303133;
  min-width: 1000px;
  .title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 12px;
  }
  .content {
    height: calc(100vh - 118px);
    box-sizing: border-box;
    padding: 16px 20px;
    .head {
      margin-bottom: 16px;
    }

    .design-table {
      .table-info {
        width: auto;
        .img {
          width: 63px;
          height: 63px;
          flex-shrink: 0;
          margin-right: 6px;
        }
        .info-text {
          width: 100%;
          color: #606266;
          .code {
            font-size: 12px;
          }
        }
      }

      .foot {
        margin-top: 12px;
      }
    }

    /deep/ .el-input__inner{
      border-radius: 2px;
    }

    /deep/ .el-input-group--append .el-input__inner {
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
    }
  }
}
</style>
